import apiClient, { safeJson } from '@/api/client';
import { normalizeBodyPhoto } from './normalize';
import { BodyPhotoListResponse, MemberBodyPhoto } from './types';

export const getAdminVisibleBodyPhotos = async ({
    centerId,
    memberId,
}: {
    centerId: string;
    memberId: string;
}) => {
    const response = await apiClient.get('v1/body-photos', {
        searchParams: {
            centerId,
            memberId,
            limit: '300',
        },
    });
    const data = await safeJson(response);
    const photos: MemberBodyPhoto[] = Array.isArray(data?.photos)
        ? data.photos
              .map(normalizeBodyPhoto)
              .filter((photo: MemberBodyPhoto) => !!photo.id && photo.images.length > 0)
        : [];

    return {
        status: response.status,
        data: { photos } as BodyPhotoListResponse,
    };
};
